import { IText } from 'fabric';
import { PillCreateConfig, PillTextbox } from '../types';
import { PILL_FACTORY_DEFAULTS } from '../constants/defaults';
import { initPill } from './init-pill';
import { resizePillToFit } from './resize-pill';

const INITIAL_WIDTH = 100;

export function createPill(cfg: PillCreateConfig): PillTextbox {
  const D = PILL_FACTORY_DEFAULTS;
  const paddingX = cfg.paddingX ?? D.paddingX;
  const paddingY = cfg.paddingY ?? D.paddingY;
  const minWidth = cfg.minWidth ?? D.minWidth;
  const borderRadius = cfg.borderRadius ?? D.borderRadius;
  const stroke = cfg.stroke ?? D.stroke;
  const strokeWidth = cfg.strokeWidth ?? D.strokeWidth;

  const pill = new IText(cfg.text, {
    originX: 'center',
    originY: 'center',
    left: cfg.left,
    top: cfg.top,
    width: INITIAL_WIDTH,
    fill: cfg.textFill,
    fontFamily: cfg.fontFamily,
    fontSize: cfg.fontSize,
    fontWeight: cfg.fontWeight ?? D.fontWeight,
    fontStyle: cfg.fontStyle ?? D.fontStyle,
    textAlign: cfg.textAlign ?? D.textAlign,
    strokeWidth: 0,
    objectCaching: false
  }) as PillTextbox;

  pill.pill = {
    fill: cfg.fill,
    stroke,
    strokeWidth,
    borderRadius,
    paddingX,
    paddingY,
    minWidth,
    ...(cfg.paddingLeft !== undefined ? { paddingLeft: cfg.paddingLeft } : {}),
    ...(cfg.paddingRight !== undefined ? { paddingRight: cfg.paddingRight } : {}),
    ...(cfg.icon ? { icon: cfg.icon } : {})
  };

  initPill(pill);
  resizePillToFit(pill);

  return pill;
}
